module.exports = __webpack_public_path__ + "static/Tablet-64f72e86d270e2fbcc7deac784d0d389.mp4";